import WordTaskForm from './word-task-form'

export default WordTaskForm
